document.addEventListener("DOMContentLoaded", function () {
  const descriptionBlock = document.querySelector('[data-block-id="description"] .prose');
  if (!descriptionBlock) return;

  const fullText = descriptionBlock.innerHTML.trim();

  // Split by spaces to count words
  const words = fullText.split(/\s+/);
  const maxWords = 100;

  if (words.length > maxWords) {
    const shortText = words.slice(0, maxWords).join(" ") + "...";

    // Build the short + hidden long content
    descriptionBlock.innerHTML = `
      <div class="short-desc">${shortText}</div>
      <div class="full-desc" style="display:none;">${fullText}</div>
      <a href="#" class="toggle-desc" style="color:#000; font-weight:600; display:inline-block; margin-top:10px;">Read more</a>
    `;

    const toggleBtn = descriptionBlock.querySelector(".toggle-desc");
    const shortDesc = descriptionBlock.querySelector(".short-desc");
    const fullDesc = descriptionBlock.querySelector(".full-desc");

    toggleBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (fullDesc.style.display === "none") {
        fullDesc.style.display = "block";
        shortDesc.style.display = "none";
        toggleBtn.textContent = "Read less";
      } else {
        fullDesc.style.display = "none";
        shortDesc.style.display = "block";
        toggleBtn.textContent = "Read more";
      }
    });
  }
});